import { __decorate, __metadata } from 'tslib';
import { Component, Input, NgModule } from '@angular/core';

var UkSpinnerComponent = /** @class */ (function () {
    function UkSpinnerComponent() {
    }
    UkSpinnerComponent = __decorate([
        Component({
            selector: 'uk-spinner',
            template: "<div class=\"loading-screen\">\r\n  <div class=\"loading-container\">\r\n    <!-- <div class=\"loading-logo\">\r\n      <img src=\"/assets/header/logo.svg\" width=\"320\" height=\"70\" />\r\n    </div> --> \r\n    <div class=\"loader\">\r\n    </div>\r\n  </div>\r\n</div>"
        })
    ], UkSpinnerComponent);
    return UkSpinnerComponent;
}());

var UkDotLoaderComponent = /** @class */ (function () {
    function UkDotLoaderComponent() {
        this.ukMsg = "";
    }
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkDotLoaderComponent.prototype, "ukMsg", void 0);
    UkDotLoaderComponent = __decorate([
        Component({
            selector: 'uk-dot-loader',
            template: "<div class=\"uikit-dot-loader uikit-dot-loader\">\r\n  <div class=\"bounce1\"></div>\r\n  <div class=\"bounce2\"></div>\r\n  <div class=\"bounce3\"></div>\r\n  <p> {{ ukMsg }}</p>\r\n</div>\r\n"
        })
    ], UkDotLoaderComponent);
    return UkDotLoaderComponent;
}());

var UKLoadersModule = /** @class */ (function () {
    function UKLoadersModule() {
    }
    UKLoadersModule = __decorate([
        NgModule({
            declarations: [
                UkSpinnerComponent,
                UkDotLoaderComponent
            ],
            exports: [
                UkSpinnerComponent,
                UkDotLoaderComponent
            ]
        })
    ], UKLoadersModule);
    return UKLoadersModule;
}());

export { UKLoadersModule, UkSpinnerComponent as ɵa, UkDotLoaderComponent as ɵb };
//# sourceMappingURL=uikit-components-uk-loaders.js.map
